/**
 * UBL Hook for Size Info Banner in Option Screen
 *
 * @description 옵션창 사이즈 추천 UBL 로깅
 */
import { useUBL, useUBLContext } from '@common/log-manager';

export const useSizeInfoBannerUBL = () => {
  const sendUBL = useUBL();
  const ublContext = useUBLContext();

  const navigation = ublContext.navigation || 'zpay_option';

  // ============ impression ============

  /**
   * 옵션창 > 사이즈 추천 노출
   */
  const sizeRecommendImpressionUBL = (catalog_product_id: string) => {
    sendUBL({
      category: 'impression',
      navigation,
      navigation_sub: ublContext.navigation_sub,
      object_section: 'size_recommend',
      object_id: 'size_recommend',
      data: { ...ublContext.data, catalog_product_id },
    });
  };

  return {
    // impression
    sizeRecommendImpressionUBL,
  };
};
